export default class Pdf {
  createOn = ''
  fileName = ''
  fileSize = ''
  id = ''
  ossKey = ''
  percent = ''
  takeOn = ''
  url = ''
  userId = ''
  selected = false
  isDelete = ''
  ossBucket = ''
  synchronousOn = ''
  updateOn = ''
  loadData = function (jsonData) {
    this.createOn = jsonData.createOn
    this.fileName = jsonData.fileName
    this.fileSize = jsonData.fileSize
    this.id = jsonData.id
    this.ossKey = jsonData.ossKey
    this.percent = jsonData.percent
    this.takeOn = jsonData.takeOn
    this.url = jsonData.url
    this.userId = jsonData.userId
    this.isDelete = jsonData.isDelete
    this.ossBucket = jsonData.ossBucket
    this.synchronousOn = jsonData.synchronousOn
    this.updateOn = jsonData.updateOn
  }
}



// WEBPACK FOOTER //
// ./src/common/model/Pdf.js